<p-dialog [header]="title" [(visible)]="display" [modal]="true" [maximizable]="true" [minY]="150" [responsive]="true"
	[closable]="true" [baseZIndex]="10000" [resizable]="true" (onHide)="closeModal($event)"
    [style]="{'width':'500px'}">
    <div [innerHtml]="infoHtml | safe: 'html'" class="modal-style"></div>
</p-dialog>